import React, {FC, useEffect, useState} from 'react'
import DialogContent from '@pixel/core/DialogContent'
import { useForm, FormProvider } from 'react-hook-form'
import {Alert, Snackbar} from "@mui/material";
import {FieldListSearchResult} from "../types/FieldList";
import FieldListView from "./FieldListView";

interface FieldListViewContainerProps {
    selectedFieldList: FieldListSearchResult
    onModalClose: () => void
}

const FieldListViewContainer: FC<FieldListViewContainerProps> = ({
    selectedFieldList,
    onModalClose
}) => {

    const [formSubmitted, setFormSubmitted] = useState(false)
    const [formResponse, _setFormResponse] = useState(null)
    const [formMessage, _setFormMessage] = useState('')

    const form = useForm({
        defaultValues: {
            name: '',
            fieldListValues: [],
            value: '',
        },
    })

    useEffect(() => {
        if (Boolean(selectedFieldList)) {
            form.reset(selectedFieldList)
        }
    }, [selectedFieldList])

    return (
        <FormProvider {...form}>
            <Snackbar open={formSubmitted} autoHideDuration={1000} onClose={() => {
                setFormSubmitted(false)
                if (formResponse == 'success') {
                    onModalClose()
                }
            }}>
                <Alert onClose={() => setFormSubmitted(false)} severity={formResponse} sx={{ width: '100%' }}>
                    {formMessage}
                </Alert>
            </Snackbar>
            <DialogContent sx={{ padding: 0 }}>
                <FieldListView selectedFieldList={selectedFieldList} />
            </DialogContent>
        </FormProvider>
    )
}

export default FieldListViewContainer
